import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "item-row-heading"
}
const _hoisted_3 = { class: "wc-coupon-row-modern__title" }
const _hoisted_4 = { class: "wc-coupon-row-modern__title-text" }
const _hoisted_5 = {
  key: 0,
  class: "wc-coupon-row-modern__badge"
}
const _hoisted_6 = {
  key: 0,
  class: "wc-item-row__spinner-wrapper d-flex"
}

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCCarouselModern from '@/components/WCCarouselModern/WCCarouselModern.vue';
import WCDigitalCouponCardModern from '@/components/WCDigitalCouponCardModern/WCDigitalCouponCardModern.vue';
import useCouponAvailability from '@/modules/coupons/composables/useCouponAvailability';
import useCoupon from '@/modules/coupons/composables/useCoupon';
import usePlatform from '@/modules/platform/composables/usePlatform';
import useCardLimitInRow from '@/composables/useCardLimitInRow';
import ExternalCoupon from '@/models/entities/items/external-coupon';

interface Props {
  useRecs?: boolean;
  isPersonalized?: boolean;
  rowSizeLimit?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCCouponRowModern',
  props: {
    useRecs: { type: Boolean, default: false },
    isPersonalized: { type: Boolean, default: false },
    rowSizeLimit: { default: 8 }
  },
  emits: ['noRecs'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();
const { couponDisplayable } = useCouponAvailability();
const { platform } = usePlatform();
const { fetchCustomerCoupons } = useCoupon({} as ExternalCoupon);

const loading = ref(false);
const loadFailedError = ref<Error | null>(null);
const totalCount = ref(-1);
const coupons = ref<ExternalCoupon[]>([]);
const rowRef = ref<HTMLElement | null>(null);

const getCardLimitInRow = useCardLimitInRow(rowRef, () => props.rowSizeLimit);

const rowTitle = computed(() => (props.useRecs ? t('couponsForYou') : t('digitalCoupons')));
const productRowClass = platform.value.isMobile
  ? 'coupon-row-class-mobile'
  : 'coupon-row-class-desktop';
const productRowCarouselClass = platform.value.isMobile
  ? 'wc-coupon-row-modern__carousel-mobile'
  : 'wc-coupon-row-modern__carousel-desktop';
const viewMoreLink = computed(() => '/cpb');
const showViewMoreButton = computed(() => {
  if (props.useRecs) {
    return true;
  }
  return totalCount.value > coupons.value.length;
});

const fetchCoupons = async () => {
  try {
    if (props.useRecs) {
      const response = await axios.get('api/cpb/recs');
      if (response?.data?.data) {
        coupons.value = response.data.data;
        totalCount.value = response.data.data.length;
      }

      if (totalCount.value <= 0) {
        emit('noRecs');
      }
    } else {
      const ps = platform.value.isMobile ? props.rowSizeLimit : getCardLimitInRow();
      const response = await axios.post('api/cpb/', { ps });
      if (response.data) {
        coupons.value = response.data.items?.filter(i => couponDisplayable(i));
        totalCount.value = response.data.totalCount;
      }
    }
  } catch (error) {
    loading.value = false;
    loadFailedError.value = error;
    console.error(error);

    if (props.useRecs) {
      emit('noRecs');
    }
  }
};

const updateData = async () => {
  loading.value = true;
  loadFailedError.value = null;
  await Promise.all([fetchCoupons(), fetchCustomerCoupons()]);
  loading.value = false;
};

onMounted(() => {
  updateData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item-row", { 'rec-row-zone': _ctx.isPersonalized }]),
    ref_key: "rowRef",
    ref: rowRef
  }, [
    (totalCount.value > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_unref(productRowClass))
        }, [
          (loadFailedError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(loadFailedError.value), 1))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (!loadFailedError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(rowTitle.value), 1)
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (_ctx.isPersonalized)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('personalized')), 1))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (showViewMoreButton.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: viewMoreLink.value,
                      class: "wc-coupon-row-modern__view-more-link",
                      "data-testid": "viewMoreButton"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('seeAll')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createTextVNode()),
          (!loadFailedError.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(WCSpinner, {
                        class: "mx-auto align-self-center",
                        size: "xl"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (!loading.value)
                  ? (_openBlock(), _createBlock(WCCarouselModern, {
                      key: 1,
                      title: rowTitle.value,
                      showArrows: true,
                      class: _normalizeClass(_unref(productRowCarouselClass))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coupons.value, (coupon) => {
                          return (_openBlock(), _createBlock(WCDigitalCouponCardModern, {
                            key: coupon.id,
                            coupon: coupon,
                            class: "wc-coupon-row-modern__card",
                            role: "listitem"
                          }, null, 8, ["coupon"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["title", "class"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})